import React, { useRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import CircularProgressWithLabel from 'irmlib/components/Controls/CircularProgressWithLabel'
import { useFormPageHandler, useMergeState } from 'irmlib/hooks'
import { XDivider } from 'irmlib/styles'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
import { TextField, CancelButton, SaveButton, Autocomplete, Select } from '../../../irmlib/src/components/FormControls'
import { ContainedButton } from 'irmlib/components/Controls/Button'
import { setBusy, clearBusy, openGeneralDialog, closeGeneralDialog, useSnackbar } from 'irmlib/containers'
import { OutlinedButton, Label } from 'irmlib/components/Controls'
import { useHistory, useLocation } from 'react-router-dom'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import * as routePaths from '../../../navigation/routePaths'
import * as constants from '../../../irmlib/src/common/constants'
import { getUser, persistFilters } from '../../../redux/global'
import { Box, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { Card, CardContent, Grid } from '@mui/material'
import Camera from 'react-html5-camera-photo'
import { storage, auth } from '../../../utils/firestore'
import { getDownloadURL, ref as storageRef, uploadBytes } from 'firebase/storage'
import { validateAccountData } from '../../../services/common/accountValidateApi.js'
import * as gdeTransactionLite from '../../../services/firestore/gdeTransactionsLite.js'
// import { makeStyles, useTheme } from 'irmlib/styles'
// import { defaultDateFormat2, countryConfig, district } from '../../../common/constants'
import { InputFileUploadButton } from './UploadButton.jsx'
import { validateAndGetAccountLevel1, validateAndGetAccountLevel2, validateAndGetAccountLevel3 } from '../../../services/skpApi'
import { errorToast } from '../../../common/functions'
import Cropper from 'react-cropper'
// import * as appConstants from '../../../services/common/appConstants.js'
import { AddBoxTransmittalsModal } from './AddBoxTransmittalsModal.jsx'
import TransmittalMaterialTable from '../Template/TransmittalTemplateList.jsx'
import styled from 'styled-components'
import Button from '@mui/material/Button'
import ImageContainer from './MultiImageContainer.jsx'
import './Camera.css'
import { ImageUploader } from './ImageUploader.jsx'
import RestrictImage from '../RestrictImage.jsx'
import Resizer from 'react-image-file-resizer'
import axios from 'axios'

/*eslint-disable*/
// const defaultSelectOption = { value: constants.defaultSelect, label: constants.defaultSelect }

const ButtonsForTemplateAssign = props =>
  <>
    <CancelButton id={'addBoxTransmittal_button_cancel'} arrRefs={props.arrRefs} onClick={props.handleCancel} />
    <XDivider width='10px' />
    <SaveButton id={'addBoxTransmittal_button_save'} arrRefs={props.arrRefs} postService={props.handleSelected} saveLabel='buttons.cancelAndGoBack' />
  </>

ButtonsForTemplateAssign.propTypes = {
  arrRefs: PropTypes.array,
  handleSelected: PropTypes.func,
  handleCancel: PropTypes.func,
  // validationErrors: PropTypes.object,
}

// Define styled component outside of the functional component
const TextButton = styled(Button)`
  && {
    width: 19vw;
    // padding: 17px 0 0 0;
    justify-content: flex-start;
    padding-left: 0
  }
`
const VisuallyHiddenButton = styled('button')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
})

const SELECT_DISTRICT = 0
const SELECT_BUILDING = 1
const SELECT_WMS_INSTANCE = 2
const SELECT_WMS_REGION = 3
const SELECT_ACOUNT_LEVEL1 = 4
const SELECT_TEMPLATE_TYPE = 5
const SELECT_ACOUNT_LEVEL2 = 6
const SELECT_ACOUNT_LEVEL3 = 7
const TOTAL_BOXES = 8
const CHECK_FIELD = 9


const getService = async (setState) => {
  const getObject = {
  }
  return Promise.resolve(getObject)
}

const AddBoxTransmittals = () => {
  const [showBanner, setShowBanner] = useState(false)
  const { t } = useTranslation()
  const userval = getUser()
  const { country, workerId, district } = userval
  const refLocalBusyCursor = useRef(null)
  const camera = useRef(null)
  const cropperRef = useRef(null)
  const tableRef = useRef()
  const history = useHistory()
  const [cropper, setCropper] = useState()
  const [previewImage, setPreviewImage] = useState(false)
  const [btnDisabled, setBtnDisabled] = useState(true)
  const [imageSrc2, setImageSrc2] = useState(null)
  const [images, setImages] = useState([])
  const [selectedImageIndex, setSelectedImageIndex] = useState(null)
  const [selectedImage, setSelectedImage] = useState(null)
  const [resetTrigger, setResetTrigger] = useState(0)
  const [isErrorSave, setIsErrorSave] = useState(false)
  const [selectedTemplateType, setSelectedTemplateType] = useState('')
  const [isReview, setIsReview] = useState(true)
  const snackBar = useSnackbar()
  const location = useLocation()
  const pathParams = location.pathname.split('/')
  const addBoxTransmittals = pathParams[1]
  const mode = pathParams[2] === 'upload'
  const retake = pathParams[2] === 'retake'
  const batchRetake = pathParams[4] !== undefined
  const transmittalId = pathParams[2] !== 'upload' ? pathParams[3] : pathParams[4]
  const userVal = getUser()
  let loggedInUserDistrict
  let defaultSelectwmsRegion
  if (location.state) {
    if (location.state.distId) {
      loggedInUserDistrict = location.state.distId
    } else {
      loggedInUserDistrict = district
    }
  } else {
    const { wmsRegion } = persistFilters()
    const distPersist = (persistFilters().district).toString()
    defaultSelectwmsRegion = wmsRegion
    loggedInUserDistrict = distPersist || district
  }

  const loggedInUserCountry = country
  const customerId = workerId
  const defaultSelectedDistrict = { value: loggedInUserDistrict, label: loggedInUserDistrict }
  // const wmsRegion = userVal.userRolesObj.wmsInstance

  const initialState = {
    lineOfBusiness: [],
    customTemplateName: [],
    workerDetails: [],
    workerDetailsGde: null,
    wmsList: [],
    skpInstance: [],
    selectedWms: '',
    selectedWmsRegion: '',
    selectedBuilding: '',
    selectedTemplate: '',
    selectedTemplateValues: [],
    WMSDistrictBuildings: [],
    WMSSystem: null,
    accountLevel1Description: '',
    validationErrors: {},
    openCustomFieldsDialog: false,
    saveStandardTempValues: [],
    addedCustomFields: [],
    renderNewTemplate: false,
    isCustomFieldsNotAdded: true,
    selectedCustomTemplateFieldNames: [],
    enableAddFieldsBtn: true,
    isTemplateChanged: false,
    wmsRegion: '',
    imageError: false,
    pageData: [],
    showTemp: false,
    addBtn: false,
    wmsRegions: [],
    countryCode: '',
    districtId: '',
    country: '',
    errorMsg: '',
    wmsForCountry: '',
    buildings: [],
    reviewOptions: [],
    templateName: '',
    haveExistingRequest: false,
    addedRefImage: '',
    addedRefImageGsPath: '',
    selectedRowImageURI: '',
    selectedRowTemplateId: '',
    selectedRowRefImage: '',
    selectedTemplateFields: {},
    addRefImage: null,
    error: '',
    skpEncoding: {},
    wmsInstances: [],
    districtsList: [defaultSelectedDistrict],
    buildingsList: [],
    showModal: false,
    imagePaths: [],
    workerName: '',
    isRestrictMultiple: false,
    templateImage: false,
    templateImageURI: false,
    isCropComplete: false,
    transmittalData: {},
    isRetakeFlow: false,
    imgReference: '',
    templateTypeList: [],
    isOffshoreExcl: false
  }

  const [state, setState, getState] = useMergeState(initialState)
  const [uploadPercentage, setUploadPercentage] = useState(0)
  const [uploadPercentageFlag, setUploadPercentageFlag] = useState(false)
  const [serverProcessFlag, setServerProcessFlag] = useState(false)
  const [compress, setCompress] = useState(0)
  const [compressActive, setCompressActive] = useState(false)

  const formTemplate = [
    {
      label: 'templates.district',
      fieldKey: 'districtId',
      defaultValue: loggedInUserDistrict,
      isRequired: true
    },
    {
      label: 'templates.building',
      fieldKey: 'buildingId',
      defaultValue: constants.defaultSelect,
      isRequired: true
    },
    {
      label: ('Search.wms'),
      fieldKey: 'wmsInstance',
      defaultValue: constants.defaultSelect,
      isRequired: true
    },
    {
      label: ('Search.wmsRegion'),
      fieldKey: 'wmsRegion',
      defaultValue: defaultSelectwmsRegion || constants.defaultSelect,
      isRequired: true
    },
    {
      label: 'templates.accountLevelOne',
      fieldKey: 'accountLevel1',
      defaultValue: '',
      isRequired: true
    },
    {
      label: 'templates.templateType',
      fieldKey: 'templateType',
      defaultValue: constants.defaultSelect,
      isRequired: true
    },
    {
      label: 'templates.accountLevelTwo',
      fieldKey: 'accountLevel2',
      defaultValue: '',
    },
    {
      label: 'templates.accountLevelThree',
      fieldKey: 'accountLevel3',
      defaultValue: '',
    },
    {
      label: 'smartCatalog.boxesPerSheet',
      fieldKey: 'totNoOfBoxes',
      isRequired: mode ? true : false
    },
    {
      label: 'templates.review',
      fieldKey: 'review',
      defaultValue: true,
    },
  ]

  useEffect(()=>{
    if(uploadPercentage == 100){
      setServerProcessFlag(true)
    }
  },[uploadPercentage])

  useEffect(() => {
    getDistricts(loggedInUserCountry, loggedInUserDistrict)
    getActivityDetails(customerId)
    transmittalId && getTransmittalData(transmittalId)
  }, [])

  useEffect(() => {
    const channel = new BroadcastChannel('tab-duplicate-checker')
    const currentPath = location.pathname

    const handleMessage = (event) => {
      const { type, path } = event.data

      if (type === 'check' && path === currentPath) {
        channel.postMessage({ type: 'duplicate', path: currentPath })
      }

      if (type === 'duplicate' && path === currentPath) {
        setShowBanner(true)
      }
    }

    channel.onmessage = handleMessage

    channel.postMessage({ type: 'check', path: currentPath })

    return () => {
      channel.close()
    }
  }, [location])

  // #1404 fetches templateType when there is no template type key on transmittal doc for Retake flow
  function getTemplateTypeForRetake(targetString) {
    if (targetString.includes('New')) {
      return 'New'
    } else if (targetString.includes('Maintenance')) {
      return 'Maintenance'
    } else {
      return ''
    }
  }

  const getTransmittalData = async (transmittalId) => {
    const data = await gdeTransactions.getTransmittal(transmittalId)
    let templateType = ''
    if (data?.templateType) {
      templateType = data?.templateType
    } else {
      templateType = getTemplateTypeForRetake(data?.templateName)
    }
    setSelectedTemplateType(templateType)
    setState({
      transmittalData: data,
      isRetakeFlow: true,
      imgReference: data?.imgReference,
      selectedWms: data?.wmsCode
    })
    // This part of the code is for getting the building and district data
    const buildings = await onChangeDistrict(data?.district)
    arrRefs[SELECT_DISTRICT]?.current?.setValue(data?.district)
    arrRefs[SELECT_BUILDING]?.current?.setValue(data?.building)
    arrRefs[SELECT_WMS_INSTANCE]?.current?.setValue(data?.wmsCode)
    arrRefs[SELECT_WMS_REGION]?.current?.setValue(data?.wmsRegion)
    arrRefs[SELECT_ACOUNT_LEVEL1]?.current?.setValue(data?.accountLevel1)
    arrRefs[SELECT_ACOUNT_LEVEL2]?.current?.setValue(data?.accountLevel2)
    arrRefs[SELECT_ACOUNT_LEVEL3]?.current?.setValue(data?.accountLevel3)
    arrRefs[SELECT_TEMPLATE_TYPE]?.current?.setValue(templateType)
    arrRefs[TOTAL_BOXES]?.current?.setValue(data?.imgDetails.numOfFiles)
    arrRefs[SELECT_DISTRICT]?.current?.setDisabled(true)
    arrRefs[SELECT_BUILDING]?.current?.setDisabled(true)
    arrRefs[SELECT_WMS_INSTANCE]?.current?.setDisabled(true)
    arrRefs[SELECT_WMS_REGION]?.current?.setDisabled(true)
    arrRefs[SELECT_ACOUNT_LEVEL1]?.current?.setDisabled(true)
    arrRefs[SELECT_ACOUNT_LEVEL2]?.current?.setDisabled(true)
    arrRefs[SELECT_ACOUNT_LEVEL3]?.current?.setDisabled(true)
    arrRefs[SELECT_TEMPLATE_TYPE]?.current?.setDisabled(true)
  }

  const handleSelectedRows = async (selectedRow) => {
    if (selectedRow !== null && selectedRow !== undefined) {
      setState({
        selectedRowTemplateId: selectedRow?.templateId,
        selectedRowRefImage: selectedRow?.imgReference,
        selectedRowImageURI: selectedRow?.imgReferenceURI,
        selectedTemplateFields: selectedRow?.templateFields
      })
    } else {
      setState({
        selectedRowTemplateId: '',
        selectedRowRefImage: '',
        selectedRowImageURI: '',
        selectedTemplateFields: ''
      })
    }
  }

  const showRequestList = async () => {
    openGeneralDialog({
      title: t('smartCatalog.smartCatalogTemplates'),
      maxWidth: 'lg',
      noTranslateTitle: true,
      message: <ContentForDialogBox />,
      buttons: <ButtonsForTemplateAssign arrRefs={arrRefs} handleCancel={handleCancel} handleSelected={tempSelected} validationErrors={getState().validationErrors} />,
      closeX: true
    })
  }

  const ContentForDialogBox = (props) => {
    return (
      <TransmittalMaterialTable
        ref={tableRef}
        data={getState()?.pageData}
        selectedRecord={false}
        handleSelectedRows={handleSelectedRows}
      />
    )
  }

  const saveActivity = () => {
    const totNoOfBoxes = Number(arrRefs[TOTAL_BOXES]?.current?.getValue())
    if (totNoOfBoxes > 0) {
      if (totNoOfBoxes > 50) {
        setIsErrorSave(true)
      } else {
        setIsErrorSave(false)
      }
    } else if (arrRefs[TOTAL_BOXES]?.current?.getValue() === undefined) {
      setIsErrorSave(false)
    } else {
      setIsErrorSave(true)
    }
    validationCheck()
  }

  const saveActivity2 = () => {
    const totNoOfBoxes = Number(arrRefs[TOTAL_BOXES]?.current?.getValue())
    const wmsInstance = arrRefs[SELECT_WMS_INSTANCE]?.current?.getValue()
    let templateName
    if (wmsInstance === 'ONEIL') {
      if (selectedTemplateType === 'New') {
        templateName = constants.templateTypes.oneilNewTransmittal
      } else {
        templateName = constants.templateTypes.oneilMaintenanceTransmittal
      }
    } else {
      if (selectedTemplateType === 'New') {
        templateName = constants.templateTypes.skpNewTransmittal
      } else {
        templateName = constants.templateTypes.skpMaintenanceTransmittal
      }
    }
    setState({ templateName: templateName })
    if (totNoOfBoxes > 0) {
      if (totNoOfBoxes > 50) {
        setIsErrorSave(true)
      } else {
        handleUploadMultiple2(totNoOfBoxes || 0)
        setIsErrorSave(false)
      }
    } else {
      setIsErrorSave(true)
    }
  }

  const tempSelected = async () => {
    if (getState()?.selectedRowTemplateId !== '') {
      setState({ addBtn: true })
      closeGeneralDialog()
    } else {
      setState({ addBtn: false })
    }
  }


  const newValidate = async () => {
    const wmsInstance = arrRefs[SELECT_WMS_INSTANCE]?.current?.getValue()
    let templateName
    if (wmsInstance === 'ONEIL') {
      if (selectedTemplateType === 'New') {
        templateName = constants.templateTypes.oneilNewTransmittal
      } else {
        templateName = constants.templateTypes.oneilMaintenanceTransmittal
      }
    } else {
      if (selectedTemplateType === 'New') {
        templateName = constants.templateTypes.skpNewTransmittal
      } else {
        templateName = constants.templateTypes.skpMaintenanceTransmittal
      }
    }
    if (getState()?.isRetakeFlow) {
      setState({
        showModal: true,
      })
    } else {
      const errors = getState()?.validationErrors
      setState({
        validationErrors: errors,
        templateName: templateName,
      })
      if (!previewImage && !getState()?.isCropComplete) {
        setState({ imageError: true })
      } else {
        setState({ imageError: false })
      }
      if (getState()?.selectedRowTemplateId !== '' && getState()?.isCropComplete) {
        setState({
          showModal: true,
        })
      }
    }
  }

  const handleShowModal = () => {
    setState({
      showModal: false
    })
  }


  const handleSave = async (numOfBoxes) => {
    const accntLevel1 = arrRefs[SELECT_ACOUNT_LEVEL1]?.current?.getValue().toUpperCase()
    const accntLevel2 = arrRefs[SELECT_ACOUNT_LEVEL2]?.current?.getValue()?.toUpperCase()?.trim()
    const accntLevel3 = arrRefs[SELECT_ACOUNT_LEVEL3]?.current?.getValue()?.toUpperCase()?.trim()
    const distId = arrRefs[SELECT_DISTRICT]?.current?.getValue()
    const wmsIns = arrRefs[SELECT_WMS_INSTANCE]?.current?.getValue().toUpperCase()
    const timeNow = Date.now()
    const documentId = timeNow.toString()
    const imgDetails = {
      imgPath: getState().imagePaths,
      numOfFiles: numOfBoxes,
    }
    if (getState()?.isRetakeFlow) {
      const data = {
        status: constants.transmittalStatus.pending,
        imgDetails: imgDetails,
        idp: {},
        idpResponse: {},
        idpMessageId: '',
        formatError: false,
        formatErrorInfo: {},
        updatedTs: (new Date()).toISOString(),
        templateImage: getState().templateImage,
        templateImageURI: getState().templateImageURI,
        processedAt: '',
        publishedAt: '',
        templateType: selectedTemplateType
      }
      await gdeTransactions.updateTransmittal(transmittalId, data)
      setTimeout(snackBar(t('toast.boxtransmittalCreated', { boxTransmittalId: transmittalId })), 50000)
      history.push(routePaths.viewBoxTransmittals)
    } else {
      const data = {
        accountLevel1: accntLevel1,
        accountLevel2: accntLevel2,
        accountLevel3: accntLevel3,
        assetType: 'Box Transmittal',
        countryCode: getState()?.countryCode,
        templateName: getState()?.templateName,
        createdTs: (new Date()).toISOString(),
        id: documentId,
        imgReference: getState()?.addedRefImage ? getState()?.addedRefImage : getState()?.selectedRowRefImage,
        imgReferenceURI: getState()?.addedRefImageGsPath ? getState()?.addedRefImageGsPath : getState()?.selectedRowImageURI,
        district: distId,
        building: getState()?.selectedBuilding,
        srcSystem: 'web',
        skpBoxNbr: [],
        status: 'pending',
        updatedTs: (new Date()).toISOString(),
        workerId: getState()?.workerDetails?.workerId,
        template: getState()?.selectedTemplateFields,
        isUploaded: false,
        isUploadInProgress: false,
        uploadTs: '',
        templateID: getState()?.selectedRowTemplateId || '',
        inBQ: false,
        isActive: true,
        idpMessageId: '',
        idpResponse: {},
        idp: {},
        imgDetails: imgDetails,
        processedAt: '',
        publishedAt: '',
        templateImage: getState().templateImage,
        templateImageURI: getState().templateImageURI,
        wmsCode: wmsIns,
        workerName: getState().workerName,
        wmsStatus: 'Pending',
        wmsRegion: wmsIns === 'SKP' ? getState().wmsRegion : getState()?.selectedWmsRegion,
        formatError: false,
        formatErrorInfo: {},
        isReprocess: false,
        templateType: selectedTemplateType,
        offshoreExcl: getState().isOffshoreExcl
      }
      await gdeTransactions.createBoxTransmittals(documentId, data)
      setTimeout(snackBar(t('toast.boxtransmittalCreated', { boxTransmittalId: documentId })), 50000)
      setPreviewImage(false)
      setState({ showModal: false, isCropComplete: false, imageError: false, imagePaths: [], isRestrictMultiple: false })
      // history.push(routePaths.viewBoxTransmittals)
    }
  }

  const handleSaveBoxTransmittals = async (numOfBoxes) => {
    const intId = setInterval(() => {
      if (getState()?.imagePaths?.length) {
        handleSave(numOfBoxes)
        clearInterval(intId)
      }
    }, 100)
  }

  const resizeImage1 = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1500, // Max width
        1500, // Max height
        'JPEG', // Output format
        80, // Quality
        0, // Rotation
        (uri) => resolve(uri), // Callback with resized image (base64)
        'file'
      )
    })

  // handle multiple box trasnmittal by sending images to api
  const handleMultipleSave2 = async (numOfBoxes) => {

    const start = Date.now()
    setCompress(0)
    const resizedImgArray = []
    setCompressActive(true)
    for (let i = 0; i < images.length; i++) {
      const resizedImage = await resizeImage1(images[i].file)
      resizedImgArray.push(resizedImage)
      setCompress((compress)=>compress+1)
    }
    setCompressActive(false)
    setBusy()

    let batchId
    const accntLevel1 = arrRefs[SELECT_ACOUNT_LEVEL1]?.current?.getValue().toUpperCase()
    const accntLevel2 = arrRefs[SELECT_ACOUNT_LEVEL2]?.current?.getValue()?.toUpperCase()?.trim()
    const accntLevel3 = arrRefs[SELECT_ACOUNT_LEVEL3]?.current?.getValue()?.toUpperCase()?.trim()
    const distId = arrRefs[SELECT_DISTRICT]?.current?.getValue()
    const wmsIns = arrRefs[SELECT_WMS_INSTANCE]?.current?.getValue().toUpperCase()
    const buildingID = arrRefs[SELECT_BUILDING]?.current?.getValue() !== constants.defaultSelect ? arrRefs[SELECT_BUILDING]?.current?.getValue() : ''
    const imgDetails = {
      // imgPath: bulkTemplateImage[i],
      numOfFiles: numOfBoxes,
    }
    let imgReference
    let imgReferenceUri
    let templateID
    let templateFields
    let templateeName
    let wmsRegion
    if (location.state) {
      if (location.state.persist) {
        const { batchId, region, persist, tempId, tempName, template, addRefImg, addRefImgUri, numOfBoxes, selectedTemplateType, buildingID, wmsIns, distId, accntLevel1, accntLevel2, accntLevel3, offshoreExcl } = location.state
        imgReference = addRefImg
        imgReferenceUri = addRefImgUri
        templateID = tempId
        templateFields = template
        templateeName = tempName
        wmsRegion = region
        setState({ isOffshoreExcl: offshoreExcl })
      } else {
        imgReference = getState()?.addedRefImage ? getState()?.addedRefImage : getState()?.selectedRowRefImage
        imgReferenceUri = getState()?.addedRefImageGsPath ? getState()?.addedRefImageGsPath : getState()?.selectedRowImageURI
        templateID = getState()?.selectedRowTemplateId || ''
        templateFields = getState()?.selectedTemplateFields
        templateeName = getState()?.templateName
        wmsRegion = wmsIns === 'SKP' ? getState().wmsRegion : getState()?.selectedWmsRegion
      }
    } else {
      imgReference = getState()?.addedRefImage ? getState()?.addedRefImage : getState()?.selectedRowRefImage
      imgReferenceUri = getState()?.addedRefImageGsPath ? getState()?.addedRefImageGsPath : getState()?.selectedRowImageURI
      templateID = getState()?.selectedRowTemplateId || ''
      templateFields = getState()?.selectedTemplateFields
      templateeName = getState()?.templateName
      wmsRegion = wmsIns === 'SKP' ? getState().wmsRegion : getState()?.selectedWmsRegion
    }
    const transmitData = {
      accountLevel1: accntLevel1,
      accountLevel2: accntLevel2,
      accountLevel3: accntLevel3,
      assetType: 'Box Transmittal',
      countryCode: getState()?.countryCode,
      templateName: getState()?.templateName ? getState()?.templateName: templateeName,
      createdTs: (new Date()).toISOString(),
      // id: documentId,
      imgReference: getState()?.addedRefImage ? getState()?.addedRefImage : imgReference,
      imgReferenceURI: getState()?.addedRefImageGsPath ? getState()?.addedRefImageGsPath : imgReferenceUri,
      district: distId,
      building: buildingID,
      srcSystem: 'web',
      skpBoxNbr: [],
      status: isReview ? 'unapproved': 'pending',
      updatedTs: (new Date()).toISOString(),
      workerId: getState()?.workerDetails?.workerId,
      template: Object.keys(getState()?.selectedTemplateFields).length ? getState()?.selectedTemplateFields : templateFields,
      isUploaded: false,
      isUploadInProgress: false,
      uploadTs: '',
      templateID: getState()?.selectedRowTemplateId ? getState()?.selectedRowTemplateId : templateID,
      inBQ: false,
      isActive: true,
      idpMessageId: '',
      idpResponse: {},
      idp: {},
      imgDetails: imgDetails,
      processedAt: '',
      publishedAt: '',
      // templateImage: bulkTemplateImage[i],
      // templateImageURI: bulkTemplateImageURI[i],
      wmsCode: wmsIns,
      workerName: getState().workerName,
      wmsStatus: 'Pending',
      wmsRegion: wmsRegion,
      formatError: false,
      formatErrorInfo: {},
      isReprocess: false,
      templateType: selectedTemplateType,
      offshoreExcl: getState().isOffshoreExcl
    }
    const apiDetails = await gdeTransactionLite.getBulkImgeAPI()
    // creating valid token for sending with req on this API call(it will expire and generate new every 15mint approx).
    const token = await auth.currentUser.getIdToken()
    const formData = new FormData()
    if (batchRetake) {
      const data = {
        imgDetails: { numOfFiles: numOfBoxes },
        status: isReview ? 'unapproved': constants.transmittalStatus.pending,
        batchId: getState()?.transmittalData?.batchId,
        id :transmittalId,
        idp: {},
        idpResponse: {},
        idpMessageId: '',
        formatError: false,
        formatErrorInfo: {},
        updatedTs: (new Date()).toISOString(),
        processedAt: '',
        publishedAt: '',
      }
      formData.append('file', resizedImgArray[0])
      formData.append('transmittal', JSON.stringify(data))
    } else {
      for (const img of resizedImgArray) {
        formData.append('file', img)
      }
      formData.append('transmittal', JSON.stringify(transmitData))
    }
    let failed
    const config = {
      headers: {
        'Authorization': 'Bearer ' + token,
      },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setUploadPercentage(percentCompleted)
      },
    }
    let errorText
    try {
      clearBusy()
      setUploadPercentageFlag(true)
      const res = await axios.post(apiDetails.endpoint, formData, config)
      const jsonData = res?.data
      batchId = jsonData?.batchId 
      failed = !jsonData?.success
      if (failed) {
        errorText = jsonData.errMsg
      } else {
        errorText = ''
      }
    } catch (error) {
      failed = true
      errorText = error?.response?.data?.errMsg
    }
    setUploadPercentageFlag(false)
    setServerProcessFlag(false)
    setState({ showModal: false })
    setImages([])
    if (!failed){
      setTimeout(snackBar(t('toast.bulkBatchTransmisson', { count: images.length, batchID: batchId })), 50000)
    } else {
      setTimeout(errorToast({ message: `${t('toast.error')}-${errorText}`, autoHideDuration: 50000, isBlocking: false }))
    }
    const addRefImg = transmitData?.imgReference
    const addRefImgUri = transmitData?.imgReferenceURI
    const tempId = transmitData?.templateID
    const template = batchRetake ? getState()?.transmittalData?.template : transmitData?.template
    const tempName = transmitData?.templateName
    const region = wmsRegion
    const refImage = getState()?.addRefImage
    const persist = true
    const fromViewBoxTransmittal = false
    if (isReview && !failed) {
      history.push(routePaths.batchTransmittals, { batchId, region, refImage, persist, tempId, tempName, template, addRefImg, addRefImgUri, numOfBoxes, selectedTemplateType, buildingID, wmsIns, distId, accntLevel1, accntLevel2, accntLevel3, fromViewBoxTransmittal, offshoreExcl: getState().isOffshoreExcl })
    } else {
      if (batchRetake && !failed) {
        history.push(routePaths.batchTransmittals)
      }
    }
  }

  const handleUploadMultiple2 = async (numOfBoxes) => {
    const intId = setInterval(() => {
      if (images?.length) {
        handleMultipleSave2(numOfBoxes)
        clearInterval(intId)
      }
    }, 100)
  }

  const handleCancel = () => {
    closeGeneralDialog()
  }

  const validationCheck = () => {
    const templateType = arrRefs[SELECT_TEMPLATE_TYPE]?.current?.getValue()
    const wmsInstance = arrRefs[SELECT_WMS_INSTANCE]?.current?.getValue()
    const actLvl1 = arrRefs[SELECT_ACOUNT_LEVEL1]?.current?.getValue()
    const buildingId = arrRefs[SELECT_BUILDING]?.current?.getValue()
    const recordCenter = arrRefs[SELECT_WMS_REGION]?.current?.getValue()
    const totNoOfBoxes = arrRefs[TOTAL_BOXES]?.current?.getValue()
    const totalBoxes = mode ? (totNoOfBoxes !== undefined) && (totNoOfBoxes !== '') : true
    if (wmsInstance === 'ONEIL' && actLvl1 !== '' && recordCenter !== '' && recordCenter !== undefined && recordCenter !== constants.defaultSelect && buildingId !== null && buildingId !== constants.defaultSelect && templateType !== '' && templateType !== null && templateType !== constants.defaultSelect && totalBoxes) {
      setBtnDisabled(false)
    } else if (wmsInstance === 'SKP' && actLvl1 !== '' && templateType !== '' && buildingId !== null && buildingId !== constants.defaultSelect && templateType !== null && templateType !== constants.defaultSelect && totalBoxes) {
      setBtnDisabled(false)
    } else {
      setBtnDisabled(true)
    }
    setState({
      // templateData: [],
      haveExistingRequest: false,
      pageData: []
    })
  }

  const getSkpInstance = async (countryCode) => {
    const doc = await gdeTransactions.getSkpInstance(countryCode)
    const wmsList = []
    if (doc && 'skp' in doc) {
      const skpInstance = doc.skp.instances[0]
      setState({ wmsRegion: skpInstance })
      if (skpInstance !== undefined) {
        wmsList.push({
          value: 'SKP', label: 'SKP'
        })
      }
    }
    if (doc && 'oneil' in doc) {
      const oneilInstance = doc.oneil.instances
      const instances = oneilInstance.map((key) => ({ value: key, label: key }))
      setState({ wmsRegions: instances })
      if (instances?.length > 0) {
        wmsList.push({
          value: 'ONEIL', label: 'ONEIL'
        })
      }
    }

    setState({
      wmsInstances: wmsList
    })
  }

  const getActivityDetails = async (userId) => {
    setBusy()
    const workerDetails = await gdeTransactions.getWorkerDetails(userId)
    const workerDetailsGde = await gdeTransactions.getWorkerRoleGde(userId)
    const [lineOfBusiness, assetType, , templateType, customTemplateName, , , wmsConfig] = await gdeTransactions.getGdeConfig()
    const countryCode = workerDetailsGde?.gdeCountryCode || workerDetails.countryCode
    await getSkpInstance(countryCode)
    // await getBuildings(workerDetailsGde?.district[0])
    const workerName = workerDetails.firstName.concat(' ', workerDetails.lastName)
    const lineOfBusinessData = Object.entries(lineOfBusiness).map(([key, value]) => ({ value: value.name, label: value.name }))
    // const templateTypeData = Object.entries(templateType).map(([key, value]) => ({ value: value.name, label: value.name }))
    const customTemplateNameData = Object.entries(customTemplateName).map(([key, value]) => ({ value: value.name, label: value.name }))
    // const wmsInstances = Object.entries(wmsConfig).map(([key, value]) => ({ value: value.name, label: value.name }))

    setState(
      {
        workerDetails: workerDetails,
        countryCode: countryCode,
        districtId: workerDetails?.gdeDistrict,
        country: workerDetailsGde?.gdeCountry,
        lineOfBusiness: lineOfBusinessData,
        customTemplateName: customTemplateNameData,
        // assetType: assetType,
        // templateType: templateTypeData,
        workerName: workerName
        // wmsInstances: wmsInstances
      })
    clearBusy()
  }

  const getDistricts = async (country, district) => {
    let districtCollection
    let buildingCollection
    if (country) {
      districtCollection = await gdeTransactions.getDistrictsByCountry(country)
      buildingCollection = await gdeTransactions.getBuildingForDistrict(district)
    } else {
      districtCollection = await gdeTransactions.getDistricts()
    }
    const districtsList = []
    districtCollection?.forEach((doc) => {
      districtsList.push({ value: doc.data().districtName, label: doc.data().districtName })
    })
    setState({ districtsList: districtsList })
  }

  const getRequestFields = async (transmitalList) => {
    const fields = transmitalList
    const storedData = localStorage.getItem('persistFilters')
    const existingData = storedData ? JSON.parse(storedData) : {}
    if (!existingData[addBoxTransmittals]) {
      existingData[addBoxTransmittals] = {}
    }
    existingData[addBoxTransmittals] = {
      workerId: workerId,
      country: country,
      district: arrRefs[SELECT_DISTRICT]?.current?.getValue() || district,
      building: arrRefs[SELECT_BUILDING]?.current?.getValue(),
      wmsInstance: arrRefs[SELECT_WMS_INSTANCE]?.current?.getValue(),
      wmsRegion: arrRefs[SELECT_WMS_REGION]?.current?.getValue()
    }
    localStorage.setItem('persistFilters', JSON.stringify(existingData))
    if (fields !== undefined) {
      const resultPromises = fields.map(doc => {
        const templateFields = Object.keys(doc.template).map((key) => {
          const data = `${key} (${doc.template[key].fieldId})`
          return data
        })
        return gdeTransactions.getUserNameById(doc.workerId).then(createdBy => {
          return {
            templateId: doc.requestId,
            customTemplateName: doc.customTemplateName,
            createdBy: createdBy,
            requestFields: templateFields,
            templateFields: doc.template,
            imgReference: doc.imgReference,
            imgReferenceURI: doc.imgReferenceURI
          }
        })
      })
      const result = await Promise.all(resultPromises)
      setState({ pageData: result })
      showRequestList(result)
      return result
    }
  }

  const selectWms = async (value) => {
    setBusy()
    const [lineOfBusiness, assetType, , templateType, customTemplateName] = await gdeTransactions.getGdeConfig()
    const templateTypeData = Object.entries(templateType).map(([key, value]) => ({ value: value.name, label: value.name }))
    setState({ selectedWms: value, templateTypeList: templateTypeData })
    validationCheck()
    clearBusy()
  }

  const selectBuilding = (value) => {
    if (value) {
      setState({ selectedBuilding: value })
    }
    validationCheck()
  }

  const selectWmsRegion = (value) => {
    if (value) {
      setState({ selectedWmsRegion: value })
    }
    validationCheck()
  }

  const validateAccountLevels = async (wmsInstance, accLevel1, accLevel2, accLevel3) => {
    setBusy()
    if (accLevel1 !== '' && accLevel3 !== '') {
      validateAndGetAccountLevel3(getState()?.wmsRegion, accLevel1, accLevel2, accLevel3)
        .then(async (result) => {
          if (result) {
            const errors = getState().validationErrors
            if (result.error) {
              errors[SELECT_ACOUNT_LEVEL3] = result.error
              setState({ validationErrors: errors, errorMsg: result.error })
            }
            if (result.success && result.statusCode === 200) {
              delete errors[SELECT_ACOUNT_LEVEL3]
              setState({ validationErrors: errors, errorMsg: '' })
              arrRefs[SELECT_ACOUNT_LEVEL3].current.clearErrorMsg()
              arrRefs[SELECT_DISTRICT]?.current?.setDisabled(true)
              arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(true)
              arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(true)
              arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
              arrRefs[SELECT_WMS_INSTANCE].current.setDisabled(true)
              arrRefs[SELECT_BUILDING]?.current?.setDisabled(true)
              arrRefs[SELECT_TEMPLATE_TYPE]?.current.setDisabled(true)
              const transmitalList = []
              const requests = await gdeTransactions.getGlobalTransmittalTemplates(wmsInstance, accLevel1, selectedTemplateType)
              if (requests !== undefined) {
                const requestArray = []
                requests.forEach((doc) => {
                  requestArray.push(doc.data())
                })
                requestArray.sort((a, b) => {
                  const accountLevelA = a.accountLevel1
                  const accountLevelB = b.accountLevel1
                  if (accountLevelA === 'GLOBALTEMPLATE' && accountLevelB !== 'GLOBALTEMPLATE') return -1
                  if (accountLevelB === 'GLOBALTEMPLATE' && accountLevelA !== 'GLOBALTEMPLATE') return 1
                  return 0
                })
                requestArray.forEach((doc) => {
                  transmitalList.push(doc)
                })
                setState({
                  haveExistingRequest: true,
                  showTemp: true,
                  accountLevel1Description: result.accountLevel1Description
                })
              }
              getRequestFields(transmitalList)
            }
            clearBusy()
          }
        })
    } else if (accLevel1 !== '' && accLevel2 !== '' && accLevel3 === '') {
      validateAndGetAccountLevel2(getState()?.wmsRegion, accLevel1, accLevel2)
        .then(async (result) => {
          if (result) {
            const errors = getState().validationErrors
            if (result.error) {
              errors[SELECT_ACOUNT_LEVEL2] = result.error
              setState({ validationErrors: errors, errorMsg: result.error })
            }
            if (result.success && result.statusCode === 200) {
              delete errors[SELECT_ACOUNT_LEVEL2]
              setState({ validationErrors: errors, errorMsg: '' })
              arrRefs[SELECT_ACOUNT_LEVEL2].current.clearErrorMsg()
              arrRefs[SELECT_DISTRICT]?.current?.setDisabled(true)
              arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(true)
              arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(true)
              arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
              arrRefs[SELECT_WMS_INSTANCE].current.setDisabled(true)
              arrRefs[SELECT_BUILDING]?.current?.setDisabled(true)
              arrRefs[SELECT_TEMPLATE_TYPE]?.current.setDisabled(true)
              const transmitalList = []
              const requests = await gdeTransactions.getGlobalTransmittalTemplates(wmsInstance, accLevel1, selectedTemplateType)
              if (requests !== undefined) {
                const requestArray = []
                requests.forEach((doc) => {
                  requestArray.push(doc.data())
                })
                requestArray.sort((a, b) => {
                  const accountLevelA = a.accountLevel1
                  const accountLevelB = b.accountLevel1
                  if (accountLevelA === 'GLOBALTEMPLATE' && accountLevelB !== 'GLOBALTEMPLATE') return -1
                  if (accountLevelB === 'GLOBALTEMPLATE' && accountLevelA !== 'GLOBALTEMPLATE') return 1
                  return 0
                })
                requestArray.forEach((doc) => {
                  transmitalList.push(doc)
                })
                setState({
                  haveExistingRequest: true,
                  showTemp: true,
                  accountLevel1Description: result.accountLevel1Description
                })
              }
              getRequestFields(transmitalList)
            }
            clearBusy()
          }
        })
    } else if (accLevel1 !== '' && accLevel2 === '' && accLevel3 === '') {
      validateAndGetAccountLevel1(getState()?.wmsRegion, accLevel1)
        .then(async (result) => {
          if (result) {
            const errors = getState().validationErrors
            if (result.error) {
              errors[SELECT_ACOUNT_LEVEL1] = result.error
              setState({ validationErrors: errors, errorMsg: result.error })
            }
            if (result.success && result.statusCode === 200) {
              delete errors[SELECT_ACOUNT_LEVEL1]
              setState({ validationErrors: errors, errorMsg: '' })
              arrRefs[SELECT_ACOUNT_LEVEL1].current.clearErrorMsg()
              arrRefs[SELECT_DISTRICT]?.current?.setDisabled(true)
              arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(true)
              arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(true)
              arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
              arrRefs[SELECT_WMS_INSTANCE].current.setDisabled(true)
              arrRefs[SELECT_BUILDING]?.current?.setDisabled(true)
              arrRefs[SELECT_TEMPLATE_TYPE]?.current.setDisabled(true)
              const transmitalList = []
              const requests = await gdeTransactions.getGlobalTransmittalTemplates(wmsInstance, accLevel1, selectedTemplateType)
              if (requests !== undefined) {
                const requestArray = []
                requests.forEach((doc) => {
                  requestArray.push(doc.data())
                })
                requestArray.sort((a, b) => {
                  const accountLevelA = a.accountLevel1
                  const accountLevelB = b.accountLevel1
                  if (accountLevelA === 'GLOBALTEMPLATE' && accountLevelB !== 'GLOBALTEMPLATE') return -1
                  if (accountLevelB === 'GLOBALTEMPLATE' && accountLevelA !== 'GLOBALTEMPLATE') return 1
                  return 0
                })
                requestArray.forEach((doc) => {
                  transmitalList.push(doc)
                })
                setState({
                  haveExistingRequest: true,
                  showTemp: true,
                  accountLevel1Description: result.accountLevel1Description
                })
              }
              getRequestFields(transmitalList)
            }
            clearBusy()
          }
      })
    }
  }

  const accountLevelValidation = async (wmsInstance, accLevel1, accLevel2, accLevel3) => {
    setBusy()
    const errors = getState().validationErrors
    const country = getState().country
    const wmsRegion = arrRefs[SELECT_WMS_REGION]?.current?.getValue()
    const result = await validateAccountData(country, wmsInstance, wmsRegion, accLevel1, accLevel2, accLevel3)
    if (result === 'success') {
      delete errors[SELECT_ACOUNT_LEVEL1]
      setState({ validationErrors: errors, errorMsg: '' })
      arrRefs[SELECT_ACOUNT_LEVEL1].current.clearErrorMsg()
      arrRefs[SELECT_BUILDING]?.current?.setDisabled(true)
      arrRefs[SELECT_DISTRICT]?.current?.setDisabled(true)
      arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(true)
      arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(true)
      arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
      arrRefs[SELECT_WMS_INSTANCE].current.setDisabled(true)
      arrRefs[SELECT_WMS_REGION]?.current?.setDisabled(true)
      arrRefs[SELECT_TEMPLATE_TYPE]?.current.setDisabled(true)
      const transmitalList = []
      const requests = await gdeTransactions.getGlobalTransmittalTemplates(wmsInstance, accLevel1, selectedTemplateType)
      if (requests !== undefined) {
        const requestArray = []
        requests.forEach((doc) => {
          requestArray.push(doc.data())
        })
        requestArray.sort((a, b) => {
          const accountLevelA = a.accountLevel1
          const accountLevelB = b.accountLevel1
          if (accountLevelA === 'GLOBALTEMPLATE' && accountLevelB !== 'GLOBALTEMPLATE') return -1
          if (accountLevelB === 'GLOBALTEMPLATE' && accountLevelA !== 'GLOBALTEMPLATE') return 1
          return 0
        })
        requestArray.forEach((doc) => {
          transmitalList.push(doc)
        })
        setState({
          haveExistingRequest: true,
          showTemp: true,
        })
      }
      getRequestFields(transmitalList)
    } else {
      let errorMsg
      if (typeof result === 'string') {
        errorMsg = `API Error: ${result}`
      } else if (typeof result === 'object') {
        // getting some unKnown error that's the reason for adding
        if (!result?.errors?.length) {
          errorMsg = `Error: ${'unknown Error'}`
        } else {
          errorMsg = `Error: ${result?.errors[0]?.error}`
        }
      }
      errors[SELECT_ACOUNT_LEVEL1] = errorMsg
      setState({ validationErrors: errors, errorMsg: errorMsg })
    }
    clearBusy()
  }

  const ButtonForReset = () =>
    <>
      <OutlinedButton onClick={closeGeneralDialog} >buttons.no</OutlinedButton>
      <ContainedButton onClick={handleReset} autoFocus>buttons.yes</ContainedButton>

    </>

  const handleReset = () => {
    setState({
      showTemp: false,
      addBtn: false,
      imagePaths: [],
      pageData: [],
      imageError: false,
      isCropComplete: false,
      isRestrictMultiple: false,
      addedRefImage: '',
      showModal: false,
      addRefImage: null
    })
    setResetTrigger(prev => prev + 1)
    setIsReview(true)
    setImageSrc2(null)
    setPreviewImage(false)
    arrRefs[SELECT_BUILDING].current.clear()
    arrRefs[SELECT_ACOUNT_LEVEL1].current.clear()
    arrRefs[SELECT_ACOUNT_LEVEL2].current.clear()
    arrRefs[SELECT_ACOUNT_LEVEL3].current.clear()
    arrRefs[SELECT_WMS_INSTANCE].current.clear()
    arrRefs[TOTAL_BOXES]?.current?.setValue('')
    arrRefs[SELECT_DISTRICT]?.current?.setDisabled(false)
    arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(false)
    arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(false)
    arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(false)
    arrRefs[SELECT_WMS_INSTANCE].current.setDisabled(false)
    arrRefs[SELECT_WMS_REGION]?.current?.setDisabled(false)
    arrRefs[SELECT_BUILDING]?.current?.setDisabled(false)
    // arrRefs[SELECT_WMS_INSTANCE].current.focus()
    arrRefs[SELECT_TEMPLATE_TYPE].current.clear()
    arrRefs[SELECT_TEMPLATE_TYPE].current.setDisabled(false)
    setBtnDisabled(true)
    history.replace({ ...location, state: null })
    closeGeneralDialog()
  }

  const handleResetDialog = () => {
    if (previewImage) {
      openGeneralDialog({
        title: t('smartCatalog.unSaved'),
        message: <Label>smartCatalog.resetText</Label>,
        translateMessage: false,
        noTranslateTitle: true,
        buttons: (
          <ButtonForReset />
        ),
        closeX: true
      })
    } else {
      handleReset()
    }
  }

  const handleValidate = async () => {
    const wmsInstance = arrRefs[SELECT_WMS_INSTANCE]?.current?.getValue()
    const accountLevelValid = arrRefs[SELECT_ACOUNT_LEVEL1]?.current?.getValue()
    const accountLevelValid2 = arrRefs[SELECT_ACOUNT_LEVEL2]?.current?.getValue()
    const accountLevelValid3 = arrRefs[SELECT_ACOUNT_LEVEL3]?.current?.getValue()
    let offshoreExcl = await gdeTransactions.getOffshoreExcludedCustomers(accountLevelValid, accountLevelValid2, accountLevelValid3)

    if (offshoreExcl === true || offshoreExcl === false) {
      setState({ isOffshoreExcl: offshoreExcl })
    }

    if (wmsInstance === 'SKP') {
      validateAccountLevels(wmsInstance, accountLevelValid, accountLevelValid2, accountLevelValid3)
    } else if (wmsInstance === 'ONEIL') {
      accountLevelValidation(wmsInstance, accountLevelValid, accountLevelValid2, accountLevelValid3)
    }
  }

  const onChangeDistrict = async (value) => {
    let buildings = []
    setBusy()
    if (value && value !== constants.defaultSelect) {
      buildings = await getBuildings(value)
    }
    clearBusy()
    return buildings
  }

  const getBuildings = async (district) => {
    let buildings = []
    if (district && district !== constants.defaultSelect) {
      const buildingsSnapshot = await gdeTransactions.getBuildingForDistrict(
        district
      )
      buildings = Object.entries(buildingsSnapshot)?.map(([key, value]) => ({
        value: key,
        label: value,
      }))
      setState({ buildingsList: buildings })
    }
    return buildings
  }

  const ManageDistrictChange = async (value) => {
    const buildings = await onChangeDistrict(value)
    // setBuildings(buildings)
    const reviewOpt = [
      { label: t('buttons.yes'), value: true },
      { label: t('buttons.no'), value: false }
    ]
    setState({
      showTemp: false,
      reviewOptions: reviewOpt,
      imagePaths: [],
      addBtn: false,
      pageData: [],
      imageError: false,
      isCropComplete: false,
      isRestrictMultiple: false,
      showModal: false,
    })
    setIsReview(true)
    setImageSrc2(null)
    setPreviewImage(false)
    arrRefs[SELECT_BUILDING]?.current?.setValue('')
    arrRefs[SELECT_ACOUNT_LEVEL1]?.current?.clear()
    arrRefs[SELECT_ACOUNT_LEVEL2]?.current?.clear()
    arrRefs[SELECT_ACOUNT_LEVEL3]?.current?.clear()
    arrRefs[SELECT_WMS_INSTANCE]?.current?.clear()
    // if (arrRefs[TOTAL_BOXES]?.current?.getValue()) {
    arrRefs[TOTAL_BOXES]?.current?.setValue('')
    // }
    arrRefs[SELECT_BUILDING]?.current?.clear()
    arrRefs[SELECT_ACOUNT_LEVEL1]?.current?.setDisabled(false)
    arrRefs[SELECT_ACOUNT_LEVEL2]?.current?.setDisabled(false)
    arrRefs[SELECT_ACOUNT_LEVEL3]?.current?.setDisabled(false)
    arrRefs[SELECT_WMS_INSTANCE]?.current?.setDisabled(false)
    arrRefs[SELECT_BUILDING]?.current?.setDisabled(false)
    if (location.state !== undefined && location.state !== null) {
      const { batchId, region, refImage, persist, tempId, tempName, template, addRefImg, addRefImgUri, numOfBoxes, selectedTemplateType, buildingID, wmsIns, distId, accntLevel1, accntLevel2, accntLevel3, offshoreExcl } = location.state
      setState({ isOffshoreExcl: offshoreExcl })
      arrRefs[SELECT_BUILDING]?.current?.setValue(buildingID)
      arrRefs[SELECT_WMS_INSTANCE]?.current?.setValue(wmsIns)
      arrRefs[SELECT_TEMPLATE_TYPE]?.current?.setValue(selectedTemplateType)
      if (region) {
        arrRefs[SELECT_WMS_REGION]?.current?.setValue(region)
      }
      arrRefs[SELECT_ACOUNT_LEVEL1]?.current?.setValue(accntLevel1)
      arrRefs[SELECT_ACOUNT_LEVEL2]?.current?.setValue(accntLevel2)
      arrRefs[SELECT_ACOUNT_LEVEL3]?.current?.setValue(accntLevel3)
      arrRefs[TOTAL_BOXES]?.current?.setValue(numOfBoxes)
      newFunc(refImage)
    } else {
      const storedData = localStorage.getItem('persistFilters')
      const existingData = storedData ? JSON.parse(storedData) : {}
      if (existingData[addBoxTransmittals]) {
        const { building, wmsInstance, wmsRegion } = persistFilters()
        arrRefs[SELECT_BUILDING]?.current?.setValue(building)
        arrRefs[SELECT_WMS_INSTANCE]?.current?.setValue(wmsInstance)
        arrRefs[SELECT_WMS_REGION]?.current?.setValue(wmsRegion)
      }
    }
    validationCheck()
  }

  const newFunc = (refImage) => {
    // arrRefs[SELECT_DISTRICT]?.current?.setValue(distId)
    arrRefs[SELECT_DISTRICT]?.current?.setDisabled(true)
    arrRefs[SELECT_BUILDING]?.current?.setDisabled(true)
    arrRefs[SELECT_ACOUNT_LEVEL1].current?.setDisabled(true)
    arrRefs[SELECT_ACOUNT_LEVEL2].current?.setDisabled(true)
    arrRefs[SELECT_ACOUNT_LEVEL3].current?.setDisabled(true)
    arrRefs[SELECT_WMS_INSTANCE].current?.setDisabled(true)
    arrRefs[SELECT_TEMPLATE_TYPE]?.current?.setDisabled(true)
    arrRefs[SELECT_WMS_REGION]?.current?.setDisabled(true)
    setState({ addBtn: true , showTemp: true, addRefImage: refImage })
  }


  const [arrRefs, data] = useFormPageHandler({
    formTemplate,
    service: getService,
    busyOverride: refLocalBusyCursor,
  })


  const handleImagesUpload = async (value) => {
    setImages(value)
  }


  const handleImageUpload = async (value) => {
    if (value) {
      setBusy()
      setState({ addRefImage: value.name })
      const imageRef = storageRef(
        storage,
        `smartCatalog/gde_refImg_${workerId}_${Date.now()}.jpg`
      )
      uploadBytes(imageRef, value)
        .then((snapshot) => {
          getDownloadURL(snapshot.ref)
            .then((url) => {
              const gspath = `gs://${snapshot.ref.bucket}/${snapshot.ref.fullPath}`
              setState({
                addedRefImage: url,
                addedRefImageGsPath: gspath,
              })
              clearBusy()
            })
            .catch((error) => {
              console.log(error.message)
              setBusy()
            })
        })
        .catch((error) => {
          console.log(error.message)
          setBusy()
        })
    }
  }

  const cropImage = async () => {
    setState({ isRestrictMultiple: true })
    if (typeof cropper !== 'undefined') {
      try {
        setBusy()
        const croppedImage = cropper.getCroppedCanvas().toDataURL()
        const imageRef = storageRef(storage, `DocumentScanner/gde_${userVal.workerId}_${Date.now()}.jpg`)
        const byteString = atob(croppedImage.split(',')[1])
        const mimeString = croppedImage.split(',')[0].split(':')[1].split(';')[0]
        const ab = new ArrayBuffer(byteString.length)
        const ia = new Uint8Array(ab)
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i)
        }
        const blob = new Blob([ab], { type: mimeString })
        const snapshot = await uploadBytes(imageRef, blob)
        const url = await getDownloadURL(snapshot.ref)
        uploadBytes(imageRef, blob)
          .then((snapshot) => {
            getDownloadURL(snapshot.ref)
              .then((url) => {
                const gspath = `gs://${snapshot.ref.bucket}/${snapshot.ref.fullPath}`
                setState({
                  imagePaths: getState().imagePaths.concat([url]),
                  templateImage: url,
                  templateImageURI: gspath
                })
              })
              .catch((error) => {
                console.log(error.message)
              })
          })
          .catch((error) => {
            console.log(error.message)
          })
        // const newImages = {
        //   src: url,
        //   alt: url,
        // }
        // setImgUrl(prevImages => [...prevImages, newImages])

        // setPreviewImage(false)
        clearBusy()
      } catch (err) {
        console.error(err.message)
      }
    }
    setState({ isCropComplete: true, imageError: false })
  }

  const retakeImage = () => {
    setPreviewImage(false)
    setState({ isCropComplete: false, imageError: false, imagePaths: [], isRestrictMultiple: false })
  }

  const MultiImageContainer = () => (
    <div>
      {selectedImageIndex !== null && (
        <ImageContainer
          images={[getState()?.transmittalData?.imgReference]}
          selectedImageIndex={selectedImageIndex}
          handleClose={handleClose}
        />
      )}
    </div>
  )

  // Utility: convert base64 to File
  function dataURLtoFile(dataurl, filename) {
    let arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  //  resize image using the react-image-file-resizer
  const resizeImage = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1500,    // Max width
        1500,    // Max height
        "JPEG", // Output format
        80,     // Quality
        0,      // Rotation
        (uri) => resolve(uri), // Callback with resized image (base64)
        "base64"
      );
    });

  const handleTakePhoto = async (dataUri) => {
    try {
      setBusy()
      // Convert dataUri (base64) to File
      const originalFile = dataURLtoFile(dataUri, "photo.jpg");

      // Resize the file
      const resizedBase64 = await resizeImage(originalFile);

      setImageSrc2(resizedBase64)
      setPreviewImage(true)
      clearBusy()
    } catch (err) {
      console.error(err.message)
    }
  }

  const handleOpen = (index) => {
    setSelectedImageIndex(index)
  }

  const handleClose = () => {
    setSelectedImageIndex(null)
  }

  document.onkeydown = function (evt) {
    if ('/' + pathParams[1] === routePaths.addBoxTransmittals && getState()?.addBtn) {
      if (evt.keyCode === 73 && evt.ctrlKey) {
        if (!previewImage) {
          const captureImage = document.getElementById('outer-circle')
          var evnt = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true,
            clientX: 20,
          })
          captureImage.dispatchEvent(evnt)
        } else {
          if (getState()?.imagePaths?.length < 1 && !getState()?.isRestrictMultiple) {
            cropImage()
          }
        }
      } else if (evt.keyCode === 66 && evt.ctrlKey) {
        newValidate()
      }
    }
  }

  const selectTemplateType = (value) => {
    setSelectedTemplateType(value)
    validationCheck()
  }

  const selectReview = (value) => {
    setIsReview(value)
  }

  state.templateTypeList.forEach((element) => {
    if (element.label !== '--Select--') {
      element.label = t(`dropdowns.${element.value}`)
    }
  })

  return (
    <>{!showBanner
      ? <MainRouteSubRoutePage
        mainTitle='routeTitles.boxTransmittals'
        subTitle='smartCatalog.addBoxTransmittals'
      >
        <Box display="flex" width="100%">
          <Box width="50%" p={1} >
            <Card>
              <CardContent>
                <Grid container spacing={4}>
                  <Grid item sm={6}>
                    <Autocomplete
                      id={'AddBoxTransmittals_district'}
                      onChange={!getState()?.isRetakeFlow && ManageDistrictChange}
                      options={state.districtsList}
                      fieldTemplate={formTemplate[SELECT_DISTRICT]}
                      ref={arrRefs[SELECT_DISTRICT]}
                      noTranslateItems
                    />
                  </Grid>

                  {state.buildingsList.length
                    ? <Grid item xs={12} sm={6}>
                      <Autocomplete
                        id={'AddBoxTransmittals_building'}
                        options={state.buildingsList}
                        fieldTemplate={formTemplate[SELECT_BUILDING]}
                        ref={arrRefs[SELECT_BUILDING]}
                        noTranslateItems
                        onChange={selectBuilding}
                      />
                    </Grid>
                    : null
                  }

                  <Grid item xs={12} sm={6}>
                    <Select
                      id={'AddBoxTransmittals_selectWms'}
                      onChange={selectWms}
                      data={data}
                      items={state?.wmsInstances}
                      fieldTemplate={formTemplate[SELECT_WMS_INSTANCE]}
                      ref={arrRefs[SELECT_WMS_INSTANCE]}
                      noTranslateItems
                      noTranslate={true}
                    />
                  </Grid>
                  {getState()?.selectedWms === 'ONEIL' || arrRefs[SELECT_WMS_INSTANCE]?.current?.getValue() === 'ONEIL'
                    ? <Grid item xs={12} sm={6}>
                      <Select
                        id={'AddBoxTransmittals_wmsRegion'}
                        data={data}
                        items={state?.wmsRegions}
                        fieldTemplate={formTemplate[SELECT_WMS_REGION]}
                        ref={arrRefs[SELECT_WMS_REGION]}
                        onChange={selectWmsRegion}
                        noTranslateItems
                        noTranslate={true}
                      />
                    </Grid>
                    : <Grid item xs={12} sm={6}></Grid>}
                  <Grid item xs={12} sm={6}>
                    <Select
                      id={'Box_transmittal_templateType'}
                      items={state.templateTypeList}
                      fieldTemplate={formTemplate[SELECT_TEMPLATE_TYPE]}
                      ref={arrRefs[SELECT_TEMPLATE_TYPE]}
                      noTranslateItems
                      onChange={selectTemplateType}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id={'AddBoxTransmittals_accountLevel'}
                      data={data}
                      fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL1]}
                      ref={arrRefs[SELECT_ACOUNT_LEVEL1]}
                      onKeyUp={validationCheck}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      id={'AddBoxTransmittals_accountLeve2'}
                      data={data}
                      fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL2]}
                      ref={arrRefs[SELECT_ACOUNT_LEVEL2]}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id={'AddBoxTransmittals_accountLeve3'}
                      data={data}
                      fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL3]}
                      ref={arrRefs[SELECT_ACOUNT_LEVEL3]}
                    />
                  </Grid>
                  {mode && !retake
                    ? <>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id={'submitImages_totBoxes'}
                          inputProps={{
                            maxLength: 2,
                            inputMode: 'numeric',
                            pattern: '[0-9]*',
                            onInput: (e) => {
                              e.target.value = e?.target?.value?.replace(/[^0-9]/g, '')
                            }
                          }}
                          onChange={saveActivity}
                          data={data}
                          helperText={
                            <span style={{ color: isErrorSave ? 'red' : 'black' }}>
                              {isErrorSave ? t(`${'messages.savePop'}`) : t(`${'messages.savePophelper'}`)}
                            </span>
                          }
                          fieldTemplate={formTemplate[TOTAL_BOXES]}
                          ref={arrRefs[TOTAL_BOXES]}
                          style={{ marginBottom: '20px' }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Select
                          id={'Box_transmittal_review'}
                          items={getState()?.reviewOptions}
                          fieldTemplate={formTemplate[CHECK_FIELD]}
                          ref={arrRefs[CHECK_FIELD]}
                          noTranslateItems
                          onChange={selectReview}
                        />
                      </Grid>
                    </>
                    : null}
                  <Grid item xs={12} sm={6}>
                    {getState()?.showTemp && !getState()?.isRetakeFlow
                      ? <>
                        <ContainedButton
                          onClick={() => handleValidate()}
                          size='small'
                          disabled={btnDisabled || getState()?.isRetakeFlow}
                          style={{
                            width: 'fitContent',
                            height: '36.5px'
                          }}
                        >{getState()?.addBtn && !getState()?.isRetakeFlow ? t('Search.ChangeTemplate').toUpperCase() : t('buttons.selectTemplate')}</ContainedButton>
                        <XDivider width='10px' />
                        <OutlinedButton
                          onClick={() => handleResetDialog()}
                          size='small'
                          style={{
                            width: 'fitContent',
                            height: '36.5px'
                          }}
                        >buttons.Reset</OutlinedButton>
                      </>
                      : !getState()?.isRetakeFlow && <ContainedButton
                        onClick={() => handleValidate()}
                        disabled={btnDisabled}
                        style={{
                          width: 'fitContent',
                          height: '36.5px'
                        }}
                      >buttons.getTemplate</ContainedButton>}
                  </Grid>
                  {getState()?.errorMsg !== '' &&
                    <Grid item xs={12} sm={6}>
                      <Typography paragraph={true} style={{ fontSize: '16px', color: '#FFF', backgroundColor: '#db4437', width: 'fit-content', padding: '1px' }}>{getState()?.errorMsg}</Typography>
                    </Grid>}
                  {getState()?.isRetakeFlow
                    ? <Grid item xs={12} sm={6}><TextButton
                      component="label"
                      tabIndex={-1}
                    >{`${t('buttons.viewReference')} `}
                      <VisuallyHiddenButton
                        onClick={() => {
                          handleOpen(0)
                          setSelectedImage([getState()?.transmittalData?.imgReference])
                        }}
                      />
                    </TextButton> </Grid>
                    : <Grid item xs={12} sm={6}>
                      <InputFileUploadButton onImageCapture={handleImageUpload} maxSize={5} allowedFormats={['JPG', 'JPEG']} prevRefImage={getState()?.addRefImage} resetTrigger={resetTrigger}/>
                    </Grid>
                  }

                </Grid>
              </CardContent>
            </Card>
          </Box>
          <XDivider width="25px" />
          <Box width="50%" >
            <Grid item xs={6}>
              {
                getState()?.addBtn || getState()?.isRetakeFlow
                  ? <Box component={'div'} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '500px', height: '450px' }}>
                    {!previewImage && (!mode || retake)
                      ? <div style={{
                        width: '500px',
                        height: '450px',
                        // border: 'none',
                        resize: 'both',
                        overflow: 'hidden'
                        // position: 'absolute'
                      }}>
                        <Camera
                          onTakePhoto={(dataUri) => { handleTakePhoto(dataUri) }}
                          isMaxResolution={true}
                          ref={camera}
                          sizeFactor={1}
                          imageType='jpg'
                          imageCompression={0}
                        />
                        {getState()?.imageError &&
                          <p style={{ position: 'absolute', color: 'red', marginTop: '5px', zIndex: 2 }}>{t('messages.clickImage')}</p>
                        }
                      </div>
                      : null
                    }
                    {!previewImage && mode &&
                      <div>
                        <ImageUploader onImageCapture={handleImagesUpload} images={images} setImages={setImages} allowedFormats={['JPG', 'JPEG']} maxSize={5} maxImages={batchRetake ? 2 : 101}/>
                        <XDivider width='40px' />
                        <ContainedButton disabled={!images.length} style={{ width: 'fitContent', height: '36.5px', margin: '2px' }} id={'addBoxTransmittal_button_save'} arrRefs={arrRefs} onClick={saveActivity2}>{t('buttons.addTransmittals')}</ContainedButton>
                      </div>
                    }
                    {getState().showModal && (!mode || retake)
                      ? (
                        <AddBoxTransmittalsModal
                          numOfBoxes={getState()?.transmittalData?.imgDetails?.numOfFiles}
                          showModal={getState().showModal}
                          handleShowModal={handleShowModal}
                          handleSaveBoxTransmittals={handleSaveBoxTransmittals}
                        />
                      )
                      : null}
                    {imageSrc2 && previewImage && (!mode || retake) &&
                      <div>
                        <Cropper
                          style={{ height: 450, width: 500, paddingBottom: 120 }}
                          zoomTo={0}
                          initialAspectRatio={1}
                          preview='.img-preview'
                          src={imageSrc2}
                          viewMode={1}
                          minCropBoxHeight={15}
                          minCropBoxWidth={15}
                          background={false}
                          responsive={true}
                          autoCropArea={100}
                          checkOrientation={false}
                          onInitialized={(instance) => {
                            setCropper(instance)
                          }}
                          guides={true}
                          ref={cropperRef}
                        />
                      </div>
                    }
                  </Box>
                  : null
              }
            </Grid>
            {uploadPercentageFlag && !serverProcessFlag ? <CircularProgressWithLabel msg={t('messages.imgUploadInfo')} value={uploadPercentage} sufix={'%'}/> : null}
            {serverProcessFlag ? <CircularProgressWithLabel msg={t('messages.dbEntriesInfo')} value={''} sufix={''}/> : null}
            {compressActive ? <CircularProgressWithLabel msg={t('messages.imgCompressInfo')} value={compress} sufix={'/'+images.length}/> : null}
            <Grid item xs={6}>

              <span style={{ display: 'flex', gap: !previewImage ? '240px' : '0px' }}>
                {
                  previewImage &&
                  <>
                    {!getState().isCropComplete && <ContainedButton style={{ width: 'fitContent', height: '36.5px', margin: '2px' }} onClick={() => cropImage()} >buttons.cropImage</ContainedButton>}
                    {previewImage && getState().isCropComplete && <SaveButton style={{ width: 'fitContent', height: '36.5px', margin: '2px' }} id={'addBoxTransmittal_button_save'} arrRefs={arrRefs} postService={newValidate} saveLabel={getState()?.isRetakeFlow ? 'buttons.submit' : 'buttons.addTransmittal'} />}
                    <OutlinedButton style={{ width: 'fitContent', height: '36.5px', margin: '2px' }} onClick={() => retakeImage()}>buttons.retakeImage</OutlinedButton>

                  </>}
              </span>
              {
                previewImage && !getState().isCropComplete &&
                <p style={{ position: 'flex', color: 'red', marginTop: '5px', zIndex: 1 }}>{t('messages.saveImage')}</p>}
            </Grid>
            {/* <Grid item xs={12}>
            </Grid> */}

          </Box>
        </Box>
        <MultiImageContainer />
      </MainRouteSubRoutePage>
      : <>{showBanner === true && <RestrictImage />}</>}
    </>
  )
}

export default AddBoxTransmittals
